export default __webpack_public_path__ + "static/media/img.fa719883.png";